const SHIFT_TIME_TYPES = {
  CUSTOM_TIME: "Custom shift time",
  STARTS_NOW: "Shift that starts now",
  ENDS_NOW: "Shift that ends now",
};

export { SHIFT_TIME_TYPES };
